var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRatingStarBlackFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2611 16.939C14.3361 16.98 14.4181 17 14.5001 17C14.6021 17 14.7041 16.968 14.7901 16.907C14.9451 16.796 15.0241 16.606 14.9931 16.417L14.0351 10.671L17.8531 6.853C17.9861 6.721 18.0331 6.526 17.9761 6.347C17.9191 6.168 17.7671 6.037 17.5821 6.006L11.8331 5.048L9.44713 0.276C9.36313 0.107 9.18913 0 9.00013 0C8.81113 0 8.63813 0.107 8.55313 0.276L6.16713 5.048L0.418133 6.006C0.233133 6.037 0.0811335 6.169 0.0241335 6.347C-0.0328665 6.525 0.0151334 6.721 0.147133 6.853L3.96513 10.671L3.00713 16.417C2.97513 16.606 3.05413 16.796 3.21013 16.907C3.36613 17.018 3.57113 17.031 3.73913 16.939L9.00013 14.07L14.2611 16.939Z",
    fill: "#626262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingStarBlackFull);
export default __webpack_public_path__ + "static/media/rating-star-black-full.9cacfd50664cfd81e708fead7a0acc79.svg";
export { ForwardRef as ReactComponent };